<app-sidebar></app-sidebar>

<section
  class="home-section relative top-0 left-[78px] w-[calc(100%-78px)] transition-all duration-500 ease-in-out "
  [ngClass]="{ 'content-open': sidebarService.isOpen() }"
>
  <app-navbar />

  <div  #mainContent
    class="main-content fixed left-[78px] w-[calc(100%-78px)] mt-4 h-[85vh] overflow-y-scroll z-[20]"
    [ngClass]="{ 'content-open': sidebarService.isOpen() }"
  >
    <router-outlet></router-outlet>
    <app-footer />
  </div>
</section>
